module.exports = __webpack_public_path__ + "static/st1-12-afdd9b37323d03e31c736324c39a5a73.jpg";